export default "__VITE_ASSET__CSvrZGd___"